import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
// import { runtime } from '../../../classes/runtime/Runtime';
import './TraitRegistryAnimation.css';
import { TraitTypeNoValue } from '../traitTypes/TraitTypeNoValue';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { runtime } from '../../../classes/runtime/Runtime';
export class TraitRegistryAnimation extends TraitRegistryCategory {
    label = 'Animation';
    constructor(parent) {
        super(parent);
        super.init();
    }
    // returning! - complete animation cycle !!!
    animateAttention = () => new TraitTypeAnimationHalf({
        isEnabled: ({ at, aspect }) => {
            if (!at.trait.value)
                return false;
            if (at.attachedCondition.isConditionTrue)
                return true;
            if (at.trait.value && aspect.aspectCssAnimation.animationByName(at.trait.value).isNamedAnimationRunning) {
                return true;
            }
            return false;
        },
        stylesheet: () => '/lib/cssAnimations/animateAttention.css',
        classNames: ({ at, aspect }) => {
            return [`animated ${at.trait.value}`];
            /*
            const { isCssAnimationRunning } = aspect.aspectCssAnimation;
    
            if (at.attachedCondition.isConditionTrue)
            if (isCssAnimationRunning) {
              return [`animated ${at.trait.value}`];
            }
            return []; */
        },
    });
    appearSpecials = {
        isEnabled: ({ at }) => {
            if (at.attachedCondition.isConditionTrue)
                return true;
            const foundLowerEnabled = [
                ...at.aspect.global.aspectKey('animateAppear').keyEnabled.conditionTrueTraits,
                ...at.aspect.global.aspectKey('animateDisappear').keyEnabled.conditionTrueTraits,
                ...at.aspect.global.aspectKey('animateTextAppear').keyEnabled.conditionTrueTraits,
                ...at.aspect.global.aspectKey('animateTextDisappear').keyEnabled.conditionTrueTraits,
            ].find(enabled => enabled.prio < at.prio);
            if (foundLowerEnabled) {
                return false;
            }
            return true;
        },
        /* beforeClassNames: ({ at, aspect }) => {
          if (at.atOf.opacity0When) {
            if (at.activeOf.opacity0When && at.activeOf.opacity0When.attachedCondition.isConditionTrue) {
              return ['opacity0'];
            }
            return [];
          }
    
          return ['opacity0'];
        }, */
    };
    animateAppear = () => new TraitTypeAnimationHalf({
        stylesheet: () => '/lib/cssAnimations/animateAppear.css',
        beforeClassNames: () => ['opacity0'],
        afterClassNames: () => ['opacity1'],
        ...this.appearSpecials,
    });
    animateDisappear = () => new TraitTypeAnimationHalf({
        isEnabled: () => true,
        stylesheet: () => '/lib/cssAnimations/animateDisappear.css',
        beforeClassNames: () => ['opacity1'],
        afterClassNames: () => ['opacity0'],
    });
    animateTextAppear = () => new TraitTypeAnimationHalf({
        stylesheet: () => '/lib/cssAnimations/animateTextAppear.css',
        beforeClassNames: () => ['opacity0'],
        afterClassNames: () => ['opacity1'],
        ...this.appearSpecials,
    });
    animateTextDisappear = () => new TraitTypeAnimationHalf({
        isEnabled: () => true,
        stylesheet: () => '/lib/cssAnimations/animateTextDisappear.css',
        beforeClassNames: () => ['opacity1'],
        afterClassNames: () => ['opacity0'],
    });
    animateTextEffect = () => new TraitTypeAnimationHalf({
        isEnabled: () => true,
        stylesheet: () => '/lib/cssAnimations/animateTextEffect.css',
    });
    animateBoxShadow = () => new TraitTypeAnimationHalf({
        isEnabled: () => true,
        stylesheet: () => '/lib/cssAnimations/animateBoxShadow.css',
    });
    animateTransform = () => new TraitTypeAnimationHalf({
        isEnabled: () => true,
        stylesheet: () => '/lib/cssAnimations/animateTransform.css',
    });
    animateBackground = () => new TraitTypeAnimationHalf({
        isEnabled: () => true,
        stylesheet: () => '/lib/cssAnimations/animateBackground.css',
    });
    animationIntensity = () => new TraitTypeNumericWithSlider({
        label: 'Animation Intensität',
        min: 0,
        max: 600,
        default: 100,
    });
    opacity0When = () => new TraitTypeNoValue();
    animateInOut = () => new TraitTypeNoValue({
        isEnabled: () => true,
        stylesheet: () => {
            return ['/lib/cssAnimations/animateAppear.css', '/lib/cssAnimations/animateDisappear.css'];
        },
        classNames: ({ at, aspect }) => {
            if (!at.attachedActive.isAtEnabled)
                return [];
            if (!at.valueOf.animateAppear)
                return [];
            const isAppearRunning = aspect.aspectCssAnimation.animationByName(at.valueOf.animateAppear).isNamedAnimationRunning;
            if (at.attachedCondition.isConditionTrue || isAppearRunning) {
                const atAppear = at.activeOf.animateAppear;
                if (atAppear) {
                    return this.animateAppear().classNames({ aspect, at: atAppear });
                }
                return [];
            }
            if (aspect.aspectCssAnimation.wasNoAnimationYet)
                return ['opacity0'];
            const atDisppear = at.activeOf.animateDisappear;
            if (atDisppear) {
                return this.animateDisappear().classNames({ aspect, at: atDisppear });
            }
            return [];
        },
        css: ({ at, aspect }) => {
            if (!at.attachedActive.isAtEnabled)
                return [];
            if (!at.valueOf.animateAppear)
                return [];
            const isAppearRunning = aspect.aspectCssAnimation.animationByName(at.valueOf.animateAppear).isNamedAnimationRunning;
            if (at.attachedCondition.isConditionTrue || isAppearRunning) {
                const atAppear = at.activeOf.animateAppear;
                if (atAppear) {
                    return this.animateAppear().css({ aspect, at: atAppear });
                }
                return [];
            }
            const atDisppear = at.activeOf.animateDisappear;
            if (atDisppear) {
                return this.animateDisappear().css({ aspect, at: atDisppear });
            }
            return [];
        },
    });
}
function ensureRevStyle(fileName, ruleName) {
    if (typeof window !== 'undefined') {
        window.runtime.runtimeScheduler.addToNextIdleStateChange(() => {
            const stylesheet = window.runtime.solidBrowserRuntime.browserStylesheets.stylesheetByName(fileName);
            if (stylesheet.isAvailable) {
                stylesheet.ensureRevStyle(ruleName);
            }
        });
    }
}
export class TraitTypeAnimationHalf extends TraitTypeSelectWithPreview {
    constructor({ stylesheet, beforeClassNames, afterClassNames, classNames, isEnabled, }) {
        super({ stylesheet });
        this.beforeClassNames = beforeClassNames;
        this.afterClassNames = afterClassNames;
        this.customClassNames = classNames;
        if (isEnabled) {
            this.isEnabled = isEnabled;
        }
    }
    beforeClassNames;
    afterClassNames;
    customClassNames;
    unifier = 'animate';
    classNames(context) {
        if (this.customClassNames)
            return this.customClassNames(context);
        const { at, aspect } = context;
        const stylesheet = this.stylesheet(context);
        if (this.beforeClassNames && !runtime.solidBrowserRuntime.browserIncludes.isStylesheetLoaded(stylesheet)) {
            return this.beforeClassNames(context);
        }
        if (!at.trait.value)
            return [];
        const { isNamedAnimationRunning, isNamedAnimationComplete } = aspect.aspectCssAnimation.animationByName(at.trait.value);
        // console.log(at.key, at.attachedCondition.isConditionTrue, at);
        if (at.attachedCondition.isConditionTrue || isNamedAnimationRunning) {
            if (stylesheet && at.trait.value) {
                ensureRevStyle(stylesheet, at.trait.value);
            }
        }
        if (isNamedAnimationRunning) {
            return [`animated ${at.trait.value}`]; // animated-fill-both
        }
        if (at.attachedCondition.isConditionTrue) {
            if (this.afterClassNames && isNamedAnimationComplete) {
                return this.afterClassNames(context);
            }
            return [`animated ${at.trait.value}`]; // animated-fill-both
        }
        if (this.beforeClassNames && aspect.aspectCssAnimation.wasNoAnimationYet) {
            return this.beforeClassNames(context);
        }
        const { isNamedAnimationRunning: isNamedAnimationRunningRev, isNamedAnimationComplete: isNamedAnimationCompleteRev, } = aspect.aspectCssAnimation.animationByName(`${at.trait.value}-rev`);
        if (isNamedAnimationRunningRev) {
            return [`animated animated-rev ${at.trait.value}-rev`];
        }
        if (this.beforeClassNames && isNamedAnimationCompleteRev) {
            return this.beforeClassNames(context);
        }
        return [`animated animated-rev ${at.trait.value}-rev`];
    }
    css({ at, aspect }) {
        if (!at.trait.value)
            return [];
        const isAnimationRunning = aspect.aspectCssAnimation.animationByName(at.trait.value);
        const cssPairs = [];
        const { isConditionTrue } = at.attachedCondition;
        if (isConditionTrue) {
            cssPairs.push({ k: 'animationIterationCount', v: at.regional.valueOf.animationIterationCount });
        }
        else if (isAnimationRunning) {
            cssPairs.push({ k: 'animationIterationCount', v: '1' });
        }
        if (isConditionTrue || isAnimationRunning) {
            cssPairs.push({ k: 'animationTimingFunction', v: at.regional.valueOf.animationTimingFunction });
            cssPairs.push({
                k: 'animationDelay',
                v: at.regional.valueOf.animationDelay && `${at.regional.valueOf.animationDelay}ms`,
            });
            cssPairs.push({
                k: 'animationDuration',
                v: at.regional.valueOf.animationDuration && `${at.regional.valueOf.animationDuration}ms`,
            });
        }
        return cssPairs;
    }
    style({ at, aspect }) {
        if (at && at.local.valueOf.animationIntensity !== 100) {
            return `.${aspect.tid} {
          --au: calc(var(--su) * ${at.regional.valueOf.animationIntensity} / 100);
          --ai: calc(${at.regional.valueOf.animationIntensity} / 100);
        }`;
        }
        return '';
    }
    aspectsTemplate = {
        core: [
            'animationIntensity',
            'animationDuration',
            'animationDelay',
            'animationTimingFunction',
            'animationIterationCount',
            'opacity0When',
        ],
    };
}
